import { Outlet } from '@tanstack/react-router';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { AppSidebar } from './app-sidebar';
import { GlobalSearchDialog } from '@/components/custom/global-search-dialog';
import { ImpersonationBanner } from '@/components/custom/impersonation-banner';

export function AppLayout(): React.ReactElement {
  // `h-svh` on SidebarInset bounds the main column to viewport height —
  // without it, SidebarProvider's `min-h-svh` lets a tall page grow past
  // the viewport and the whole document scrolls (a two-pane page gets
  // its right panel pushed below the fold). With a hard height, inner
  // panes that mark themselves `overflow-y-auto` actually scroll
  // independently. `min-h-0` on the outlet wrapper is the matching half:
  // a `flex-1` child without `min-h-0` ignores the parent's bound and
  // grows to its content size, breaking the same overflow contract.
  return (
    <SidebarProvider defaultOpen={false}>
      <AppSidebar />
      <SidebarInset className="h-svh min-w-0 overflow-hidden">
        <ImpersonationBanner />
        <div className="min-h-0 flex-1 overflow-hidden min-w-0">
          <Outlet />
        </div>
      </SidebarInset>
      <GlobalSearchDialog />
    </SidebarProvider>
  );
}
